export default [
  {
    path: '/rental/report/MY_004/home_rental_charges',
    name: 'MY_004_DailyHomeRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_004_report" */ './DailyHomeRentalCharges.vue'
      )
  },
  {
    path: '/rental/report/MY_004/income_develop',
    name: 'MY_004_DailyIncomeOfDevelopAndSecuity',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_004_report" */ './DailyIncomeOfDevelop.vue'
      )
  },
  {
    path: '/report/report/MY_004/rental_charges',
    name: 'MY_004_MothlyRentalCharges',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_004_report" */ './MothlyRentalCharges.vue'
      )
  },
  {
    path: '/report/report/MY_004/income_others',
    name: 'MY_004_MothlyIncomeOfOthers',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_004_report" */ './MothlyIncomeOfOthers.vue'
      )
  },
  {
    path: '/report/report/MY_004/balance_due_home_rental',
    name: 'MY_004_MothlyBalanceDueListForHomeRental',
    component: () =>
      import(
        /* webpackChunkName: "rental_MY_004_report" */ './MothlyBalanceDueListForHomeRental.vue'
      )
  }
]
